import { Modal } from 'antd';
import React, { useState } from 'react';
import { RiKey2Line } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import Apis from '../../../../api';
import HSButton from '../../../common/Button';
import NormalInput from '../../../common/NormalInput';
import MessageActions from '../../../message/redux/actions';


type Props = {
    open: boolean;
    setOpen: (arg: boolean) => void;
}


const UpdatePasswordModal: React.FC<Props> = ({ open, setOpen }) => {
    const dispatch = useDispatch();
    const [fields, setFields] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [validate, setIsValidate] = useState(false);
    const [loader, setLoader] = useState(false);

    const onFieldChange = (data: { name: string; value?: number | string }) => {
        const { name, value } = data;

        setFields({ ...fields, [name]: value });
    };

    const onClickCancel = () => {
        setOpen(false);
        setIsValidate(false);
        setFields({
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
        })
    };
    const updateUserPassword = () => {
        setIsValidate(true);
        if (
            !fields.oldPassword ||
            fields.oldPassword.trim() === '' ||
            !fields.newPassword ||
            fields.newPassword.trim() === '' ||
            fields.newPassword !== fields.confirmPassword
        ) {
            return;
        }
        setIsValidate(false);
        setLoader(true);
        Apis.updatePassword(fields.oldPassword, fields.newPassword)
            .then(() => {
                onClickCancel()
                dispatch(MessageActions.showMessage({ error: false, text: 'Password updated successfully' }));
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoader(false);
            });
    };

    return (
        <Modal
            open={open}
            title="Update Password"
            footer={null}
            onCancel={onClickCancel}
            onOk={onClickCancel}
            centered
        >
            <div>
                <div className='pt-2'>
                    <NormalInput
                        title='Current Password'
                        placeholder="Current Password"
                        isRequired
                        name="oldPassword"
                        type="password"
                        value={fields.oldPassword}
                        onChange={onFieldChange}
                        prefix={<RiKey2Line color="rgb(196, 196, 196)" size={'1rem'} />}
                        error={validate && (!fields.oldPassword || fields.oldPassword.trim() === '')}
                    />

                    {validate && (!fields.oldPassword || fields.oldPassword.trim() === '') && (
                        <div className="common_error px-3">Please enter current password</div>
                    )}
                </div>
                <div className='pt-2'>
                    <NormalInput
                        title='New Password'
                        placeholder="New Password"
                        isRequired
                        name="newPassword"
                        type="password"
                        value={fields.newPassword}
                        onChange={onFieldChange}

                        prefix={<RiKey2Line color="rgb(196, 196, 196)" size={'1rem'} />}
                        error={validate && (!fields.newPassword || fields.newPassword.trim() === '')}
                    />

                    {validate && (!fields.newPassword || fields.newPassword.trim() === '') && (
                        <div className="common_error px-3">Please enter new password</div>
                    )}
                </div>
                <div className='pt-2'>
                    <NormalInput
                        title='Confirm Password'
                        placeholder="Confirm password"
                        isRequired
                        name="confirmPassword"
                        type="password"
                        value={fields.confirmPassword}
                        onChange={onFieldChange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                updateUserPassword();
                            }
                        }}
                        prefix={<RiKey2Line color="rgb(196, 196, 196)" size={'1rem'} />}
                        error={validate && fields.newPassword !== fields.confirmPassword}
                    />
                    {validate && fields.newPassword !== fields.confirmPassword && (
                        <div className="common_error px-3">
                            Password don't match, Please enter correct password
                        </div>
                    )}
                </div>
                <div className="flex justify-center items-center py-6">
                    <HSButton
                        title="Confirm"
                        loading={loader}
                        onClick={updateUserPassword}
                        style={{ borderRadius: 999, margin: '0 4px' }}
                    />
                    <HSButton
                        title="Cancel"
                        light
                        onClick={onClickCancel}
                        style={{ borderRadius: 999, margin: '0 4px' }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default UpdatePasswordModal;
